import * as React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import { components, OptionProps } from 'react-select'
// themes
import { colors } from 'themes'
// types
import { IOption } from 'components/FormElements/Select'

const Wrapper = styled('div')<{ $isSelected: boolean }>`
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      > div {
        background: ${colors.gray240};
      }
    `}
`

const DefaultOption: React.FC<OptionProps<IOption> & any> = (props) => {
  const [isFocused, setIsSelected] = React.useState(false)

  const onMouseEnter = () => setIsSelected(true)
  const onMouseLeave = () => setIsSelected(false)

  const currentValue = props.selectProps?.input?.value
  const currentOption = props.data

  const getIsSelected = (): boolean => {
    const valueMatches = currentOption.value === currentValue?.value

    if (currentValue?.relatedFieldId) {
      return currentOption.relatedFieldId === currentValue.relatedFieldId && valueMatches
    }

    //  used for create related form transaction
    if (currentValue?.sourceFieldId) {
      return currentOption.sourceFieldId === currentValue.sourceFieldId && valueMatches
    }

    return valueMatches
  }

  const isSelected = getIsSelected()

  return (
    <Wrapper
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      $isSelected={isSelected}
      data-entity-id={currentOption.value}>
      <components.Option {...props} isFocused={isFocused || isSelected} />
    </Wrapper>
  )
}

export default DefaultOption
